import { render } from "./BaseOverlay.vue?vue&type=template&id=18b4bb8a"
import script from "./BaseOverlay.vue?vue&type=script&lang=js"
export * from "./BaseOverlay.vue?vue&type=script&lang=js"

import "./BaseOverlay.vue?vue&type=style&index=0&id=18b4bb8a&lang=scss"
script.render = render

export default script